import { useCallback, useEffect, useState } from "react";

const KEY = "kanvia-consent-v1";

function applyConsent(analitica) {
  if (analitica) {
    window.__kanviaInitPostHog?.();
    window.posthog?.opt_in_capturing?.();
  } else if (window.__kanviaPostHogStarted) {
    window.posthog?.opt_out_capturing?.();
  }
}

function readStored() {
  try {
    const s = JSON.parse(localStorage.getItem(KEY));
    if (s && typeof s.analitica === "boolean") return s;
  } catch (err) {
    console.warn("No se pudo leer el consentimiento guardado:", err);
  }
  return null;
}

function CookiePanel({ analitica, onChange }) {
  return (
    <div className="mt-5 max-w-3xl border-t border-noche/15 pt-5" data-testid="cookie-panel">
      <label className="flex items-start gap-3">
        <input type="checkbox" className="chk-box" checked disabled data-testid="cookie-check-necesarias" />
        <span className="text-[13px] leading-relaxed text-noche/80">
          <strong className="font-display display-track text-sm">Técnicas necesarias</strong>{" "}
          — guardan tu elección de consentimiento. Siempre activas.
        </span>
      </label>
      <label className="mt-4 flex cursor-pointer items-start gap-3">
        <input
          type="checkbox"
          className="chk-box"
          checked={analitica}
          onChange={(e) => onChange(e.target.checked)}
          data-testid="cookie-check-analitica"
        />
        <span className="text-[13px] leading-relaxed text-noche/80">
          <strong className="font-display display-track text-sm">Analítica (PostHog)</strong>{" "}
          — medición anónima y agregada del uso de la web. Desactivada
          por defecto.
        </span>
      </label>
    </div>
  );
}

function CookieActions({ panel, analitica, onSave, onConfig }) {
  return (
    <div className="mt-6 flex flex-wrap gap-3">
      {panel ? (
        <button type="button" className="btn btn-dark" onClick={() => onSave(analitica)} data-testid="cookie-save-button">
          Guardar preferencias
        </button>
      ) : (
        <>
          <button type="button" className="btn btn-dark" onClick={() => onSave(true)} data-testid="cookie-accept-button">
            Aceptar
          </button>
          <button type="button" className="btn btn-dark" onClick={() => onSave(false)} data-testid="cookie-reject-button">
            Rechazar
          </button>
          <button type="button" className="btn btn-dark" onClick={onConfig} data-testid="cookie-config-button">
            Configurar
          </button>
        </>
      )}
    </div>
  );
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [panel, setPanel] = useState(false);
  const [analitica, setAnalitica] = useState(false);

  useEffect(() => {
    const stored = readStored();
    if (stored) {
      applyConsent(stored.analitica);
    } else {
      applyConsent(false);
      setVisible(true);
    }
    const onOpen = () => {
      const s = readStored();
      setAnalitica(s?.analitica === true);
      setPanel(true);
      setVisible(true);
    };
    window.addEventListener("kanvia:cookies", onOpen);
    return () => window.removeEventListener("kanvia:cookies", onOpen);
  }, []);

  const save = useCallback((value) => {
    localStorage.setItem(
      KEY,
      JSON.stringify({ analitica: value, fecha: new Date().toISOString() })
    );
    applyConsent(value);
    setVisible(false);
    setPanel(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[80] border-t border-noche/20 bg-papel text-noche shadow-[0_-12px_40px_rgba(0,0,0,0.25)]"
      role="dialog"
      aria-label="Aviso de cookies"
      data-testid="cookie-banner"
    >
      <div className="mx-auto max-w-7xl px-5 py-6 md:px-8">
        <p className="max-w-3xl text-[13px] leading-relaxed text-noche/80">
          Usamos cookies técnicas imprescindibles y, solo si tú lo aceptas,
          analítica anónima para entender cómo se usa la web. Nada de
          marketing. Puedes cambiar tu elección cuando quieras desde
          «Configurar cookies», en el pie de la página.{" "}
          <a
            href="/politica-de-cookies"
            className="underline underline-offset-4"
            data-testid="cookie-banner-policy-link"
          >
            Política de cookies
          </a>
        </p>

        {panel && <CookiePanel analitica={analitica} onChange={setAnalitica} />}
        <CookieActions panel={panel} analitica={analitica} onSave={save} onConfig={() => setPanel(true)} />
      </div>
    </div>
  );
}
